import styled from "styled-components";

import { styled as styledMui } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";

import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import VerifiedIcon from "@mui/icons-material/Verified";
import PaidIcon from "@mui/icons-material/Paid";
import MoveToInboxIcon from "@mui/icons-material/MoveToInbox";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";
import NewReleasesIcon from "@mui/icons-material/NewReleases";

import device from "src/styles/device";

const WrapStepper = styled.div`
  width: 60%;
  margin: 40px auto 0 auto;

  @media ${device.tablet} {
    width: 90%;
  }
  @media ${device.mobileL} {
    width: 100%;
    margin: 25px auto 0 auto;
  }
`;

const ColorlibConnector = styledMui(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 24,
    [theme.breakpoints.down("sm")]: {
      top: 19,
    },
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#e04312",
      // backgroundImage:
      //   "linear-gradient(136deg,rgb(40,182,101) 0, rgb(33,150,83) 50%, rgb(26,118,65) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundColor: "#e04312",
      // backgroundImage:
      //   "linear-gradient(136deg,rgb(40,182,101) 0, rgb(33,150,83) 50%, rgb(26,118,65) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styledMui("div")(({ theme, ownerState }) => ({
  backgroundColor:
    ownerState?.active || ownerState?.completed ? "#e04312" : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 45,
  height: 45,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  boxShadow:
    ownerState?.active || ownerState?.completed
      ? "0 4px 10px 0 rgba(0,0,0,.25)"
      : "none",

  [theme.breakpoints.down("sm")]: {
    width: 40,
    height: 40,
  },
}));

const StepLabelMui = styled(StepLabel)`
  @media ${device.mobileL} {
    .MuiStepLabel-label {
      margin-top: 12px !important;
      font-size: 0.75rem;
    }
  }
`;

const ShippingStepper = ({ status }) => {
  const steps = [
    "รอจัดส่ง",
    "รอชำระค่าจัดส่ง",
    "เตรียมจัดส่ง",
    "กำลังจัดส่ง",
    "รอยืนยันรับสินค้า",
    `${status === "failed" ? "จัดส่งไม่สำเร็จ" : "จัดส่งสำเร็จ"}`,
  ];

  const handleStatus = (status) => {
    switch (status) {
      case "pending":
        return 0;
      case "confirmed":
        return 1;
      case "preparing":
        return 2;
      case "delivering":
        return 3;
      case "shipped":
        return 4;
      case "delivered":
        return 5;
      case "failed":
        return 5;
      default:
        return 0;
    }
  };

  const ColorlibStepIcon = ({ active, completed, className, icon }) => {
    const icons = {
      1: <HourglassBottomIcon sx={{ fontSize: { xs: 18, sm: 26 } }} />,
      2: <PaidIcon sx={{ fontSize: { xs: 18, sm: 26 } }} />,
      3: <MoveToInboxIcon sx={{ fontSize: { xs: 18, sm: 26 } }} />,
      4: <LocalShippingIcon sx={{ fontSize: { xs: 18, sm: 26 } }} />,
      5: <PublishedWithChangesIcon sx={{ fontSize: { xs: 18, sm: 26 } }} />,
      6:
        status === "failed" ? (
          <NewReleasesIcon sx={{ fontSize: { xs: 18, sm: 26 } }} />
        ) : (
          <VerifiedIcon sx={{ fontSize: { xs: 18, sm: 26 } }} />
        ),
    };

    return (
      <ColorlibStepIconRoot
        ownerState={{ completed, active }}
        className={className}
      >
        {icons[String(icon)]}
      </ColorlibStepIconRoot>
    );
  };

  return (
    <WrapStepper>
      <Stack sx={{ width: "100%" }} spacing={4}>
        <Stepper
          alternativeLabel
          activeStep={handleStatus(status)}
          connector={<ColorlibConnector />}
        >
          {steps.map((label) => (
            <Step key={label}>
              <StepLabelMui StepIconComponent={ColorlibStepIcon}>
                {label}
              </StepLabelMui>
            </Step>
          ))}
        </Stepper>
      </Stack>
    </WrapStepper>
  );
};

export default ShippingStepper;
